import type {ImageGenerator} from "@cm/material-nodes"
import type {FundamentalLikeNode} from "#template/role-markers"
import {createFundamentalMarker} from "#template/role-markers"

export const imageLikeMarker = Symbol("ImageLike")

export interface ImageLikeNode extends FundamentalLikeNode<ImageGenerator | null> {
    readonly [imageLikeMarker]: true
}

export const imageMarker = createFundamentalMarker<ImageLikeNode>(imageLikeMarker)
export const {isLikeNode: isImageLikeNode, isLikeNodeClass: isImageLikeNodeClass, like: imageLike} = imageMarker
